var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoJpg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 70,
    viewBox: "0 0 60 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "2pyct6czca"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 15548",
    style: {
      fill: "none"
    },
    d: "M0 0h60v70H0z"
  }))), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59791",
    d: "m0 38.841 4.5 3.765v-3.765z",
    transform: "translate(0 -11.227)",
    style: {
      fill: "#2264a0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 890"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 889",
    style: {
      clipPath: "url(#2pyct6czca)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59792",
    d: "M44.456 0H8.789a3.4 3.4 0 0 0-3.378 3.419v63.163A3.4 3.4 0 0 0 8.789 70h49.442a3.4 3.4 0 0 0 3.378-3.418V17.453a.712.712 0 0 0-.2-.5L44.955.21a.7.7 0 0 0-.5-.21",
    transform: "translate(-1.61)",
    style: {
      fill: "#ddd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59793",
    d: "M58.529 69.578H9.086a2.692 2.692 0 0 1-2.675-2.708V3.707A2.692 2.692 0 0 1 9.086 1h35.668L61.2 17.742V66.87a2.692 2.692 0 0 1-2.676 2.708",
    transform: "translate(-1.907 -.289)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 15543",
    transform: "translate(15.471 34.289)",
    style: {
      fill: "#ddd"
    },
    d: "M0 0h32.859v1.422H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 15544",
    transform: "translate(15.471 42.829)",
    style: {
      fill: "#ddd"
    },
    d: "M0 0h32.859v1.422H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 15545",
    transform: "translate(15.471 51.369)",
    style: {
      fill: "#ddd"
    },
    d: "M0 0h32.859v1.422H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 15546",
    transform: "translate(15.471 59.91)",
    style: {
      fill: "#ddd"
    },
    d: "M0 0h32.859v1.422H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 15547",
    transform: "translate(0 11.904)",
    style: {
      fill: "#0e9edd"
    },
    d: "M0 0h34.523v15.71H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59794",
    d: "M16.353 24.023h1.027v4.212a1.8 1.8 0 0 1-.532 1.37 1.952 1.952 0 0 1-1.4.507 2.012 2.012 0 0 1-1.435-.475 1.719 1.719 0 0 1-.506-1.32h1.027a1 1 0 0 0 .235.72.9.9 0 0 0 .679.241.838.838 0 0 0 .659-.278 1.119 1.119 0 0 0 .247-.769z",
    transform: "translate(-4.017 -6.944)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59795",
    d: "M21.85 27.8v2.23h-1.031v-6.007h2.271a2.282 2.282 0 0 1 1.58.524 1.776 1.776 0 0 1 .585 1.388 1.713 1.713 0 0 1-.573 1.375 2.386 2.386 0 0 1-1.6.492zm0-.842h1.24a1.212 1.212 0 0 0 .84-.262.971.971 0 0 0 .29-.758 1.046 1.046 0 0 0-.294-.777 1.125 1.125 0 0 0-.807-.3H21.85z",
    transform: "translate(-6.193 -6.944)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59796",
    d: "M33.011 29.216a1.975 1.975 0 0 1-.893.643 3.6 3.6 0 0 1-1.3.219 2.524 2.524 0 0 1-1.321-.343 2.271 2.271 0 0 1-.887-.98 3.467 3.467 0 0 1-.325-1.487V26.8a3.208 3.208 0 0 1 .644-2.128 2.224 2.224 0 0 1 1.8-.765 2.349 2.349 0 0 1 1.574.5 2.154 2.154 0 0 1 .7 1.43H32a1.142 1.142 0 0 0-1.243-1.085 1.213 1.213 0 0 0-1.054.505 2.6 2.6 0 0 0-.373 1.482v.461a2.466 2.466 0 0 0 .406 1.511 1.331 1.331 0 0 0 1.127.537 1.476 1.476 0 0 0 1.125-.363v-1.179h-1.227v-.792h2.25z",
    transform: "translate(-8.415 -6.91)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59797",
    d: "M15.221 30.429a2.524 2.524 0 0 1-1.794-.617 2.243 2.243 0 0 1-.674-1.711.53.53 0 0 1 .527-.533h1.027a.53.53 0 0 1 .527.533.53.53 0 0 0 .084.346.451.451 0 0 0 .3.081.318.318 0 0 0 .27-.1.619.619 0 0 0 .112-.414v-4.208a.53.53 0 0 1 .527-.533h1.027a.53.53 0 0 1 .527.533v4.212a2.326 2.326 0 0 1-.7 1.758 2.464 2.464 0 0 1-1.765.653",
    transform: "translate(-3.794 -6.727)",
    style: {
      fill: "#2264a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59798",
    d: "M21.626 30.346h-1.031a.53.53 0 0 1-.527-.533v-6.007a.53.53 0 0 1 .527-.533h2.271a2.8 2.8 0 0 1 1.929.658 2.3 2.3 0 0 1 .763 1.787A2.234 2.234 0 0 1 24.8 27.5a2.9 2.9 0 0 1-1.945.618h-.7v1.695a.53.53 0 0 1-.527.533m-.5-3.448v.533a.533.533 0 0 1 .181-.267.539.539 0 0 1-.181-.267m1.031-.687h.712a.781.781 0 0 0 .49-.127c.027-.025.113-.1.113-.36a.505.505 0 0 0-.136-.4.579.579 0 0 0-.447-.147h-.733zm-1.031-1.871v.154a.53.53 0 0 1 .074-.154z",
    transform: "translate(-5.97 -6.727)",
    style: {
      fill: "#2264a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59799",
    d: "M30.6 30.4a3.057 3.057 0 0 1-1.588-.416 2.806 2.806 0 0 1-1.092-1.2 4.014 4.014 0 0 1-.379-1.716v-.478a3.737 3.737 0 0 1 .77-2.473 2.735 2.735 0 0 1 2.2-.952 2.856 2.856 0 0 1 1.913.623 2.677 2.677 0 0 1 .884 1.77.539.539 0 0 1-.127.419.525.525 0 0 1-.4.181h-1.008a.528.528 0 0 1-.521-.449c-.073-.464-.269-.636-.723-.636a.682.682 0 0 0-.627.285 2.136 2.136 0 0 0-.273 1.175v.455a1.97 1.97 0 0 0 .3 1.187.806.806 0 0 0 .708.328 1.52 1.52 0 0 0 .6-.1v-.376h-.7a.53.53 0 0 1-.527-.533V26.7a.53.53 0 0 1 .527-.533h2.25a.53.53 0 0 1 .527.533V29a.539.539 0 0 1-.109.324 2.5 2.5 0 0 1-1.124.818 4.147 4.147 0 0 1-1.481.258m2.19-1.4zm-.567-1.769a.532.532 0 0 1 .04.092v-.092z",
    transform: "translate(-8.192 -6.694)",
    style: {
      fill: "#2264a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59800",
    d: "M16.353 24.023h1.027v4.212a1.8 1.8 0 0 1-.532 1.37 1.952 1.952 0 0 1-1.4.507 2.012 2.012 0 0 1-1.435-.475 1.719 1.719 0 0 1-.506-1.32h1.027a1 1 0 0 0 .235.72.9.9 0 0 0 .679.241.838.838 0 0 0 .659-.278 1.119 1.119 0 0 0 .247-.769z",
    transform: "translate(-4.017 -6.944)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59801",
    d: "M21.85 27.8v2.23h-1.031v-6.007h2.271a2.282 2.282 0 0 1 1.58.524 1.776 1.776 0 0 1 .585 1.388 1.713 1.713 0 0 1-.573 1.375 2.386 2.386 0 0 1-1.6.492zm0-.842h1.24a1.212 1.212 0 0 0 .84-.262.971.971 0 0 0 .29-.758 1.046 1.046 0 0 0-.294-.777 1.125 1.125 0 0 0-.807-.3H21.85z",
    transform: "translate(-6.193 -6.944)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59802",
    d: "M33.011 29.216a1.975 1.975 0 0 1-.893.643 3.6 3.6 0 0 1-1.3.219 2.524 2.524 0 0 1-1.321-.343 2.271 2.271 0 0 1-.887-.98 3.467 3.467 0 0 1-.325-1.487V26.8a3.208 3.208 0 0 1 .644-2.128 2.224 2.224 0 0 1 1.8-.765 2.349 2.349 0 0 1 1.574.5 2.154 2.154 0 0 1 .7 1.43H32a1.142 1.142 0 0 0-1.243-1.085 1.213 1.213 0 0 0-1.054.505 2.6 2.6 0 0 0-.373 1.482v.461a2.466 2.466 0 0 0 .406 1.511 1.331 1.331 0 0 0 1.127.537 1.476 1.476 0 0 0 1.125-.363v-1.179h-1.227v-.792h2.25z",
    transform: "translate(-8.415 -6.91)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59803",
    d: "M62.067 17.453h16.075L60.989 0v16.362a1.085 1.085 0 0 0 1.078 1.091",
    transform: "translate(-18.142)",
    style: {
      fill: "#ddd"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoJpg);
export default __webpack_public_path__ + "static/media/ico_jpg.4c0a27a358ad44bf7f1bbc410c50adb6.svg";
export { ForwardRef as ReactComponent };